import { Helmet } from "react-helmet-async";

const SITE_NAME = "AlikamaFish";
const SITE_DESC = "Premium ocean-fresh seafood, smoked specialities, cooking classes, weekly subscriptions and private event chef in the UK.";
const SITE_URL = typeof window !== "undefined" ? window.location.origin : "https://alikamafish.co.uk";
const DEFAULT_IMAGE = `${SITE_URL}/og-default.jpg`;

/**
 * Drop-in SEO component. Pass `title` and `description`; optional `image`,
 * `path` (defaults to current pathname), and `type` (article / product / website).
 */
export default function SEO({
  title,
  description = SITE_DESC,
  image = DEFAULT_IMAGE,
  path,
  type = "website",
  jsonLd = null,
}) {
  const fullTitle = title ? `${title} · ${SITE_NAME}` : SITE_NAME;
  const url = path
    ? `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`
    : typeof window !== "undefined"
      ? window.location.href
      : SITE_URL;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
